module.exports = __webpack_public_path__ + "img/bohrungen-1.10c1d694.svg";